import { defineComponent } from 'vue';
import CustomImage from '@/components/common/custom-image.vue';
export default defineComponent({
    components: { CustomImage: CustomImage },
    setup: function () {
        return {};
    }
});
